import {isSafari, ISWECHAT, getIOSVersion} from './useragent';

/**
 * 腾讯体系下注册了 applink 的调用
 *
 * @param {Object} obj
 */
function callByAppLink(obj) {
    let appConfig = callIOS.appConfig;
    let applink = appConfig.APPLINK;
    let appurl = '';
    let protocol = callIOS.appConfig.PROTOCOL;
    let iosSchema = protocol + obj.action + '?' + obj.params;
    // + '&analyticsna=' + obj.analytics;

    appurl = applink + encodeURIComponent(iosSchema);
    location.href = appurl;
}

/**
 * ios9+ 可以使用 apple 提供的 universallink 进行调起
 *
 * @param {Object} obj
 */
function callByUniversalLink(obj) {
    let appConfig = callIOS.appConfig;
    let universalLink = appConfig.UNIVERSALLINK;
    let appurl = '';
    let protocol = appConfig.PROTOCOL;

    let iosSchema = protocol + obj.action;

    appurl = universalLink + encodeURIComponent(iosSchema);
    let downloadLink = document.createElement("a");
    downloadLink.href = appurl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

/**
 * 基本 schema 调起
 *
 * @param {Object} obj
 */
function callBySchema(obj) {
    let appConfig = callIOS.appConfig;
    let protocol = appConfig.PROTOCOL;
    let timer = null;
    let count = 0;
    let startTime = Date.parse(new Date());
    let node = document.createElement('iframe');
    let body = document.body;
    let iosSchema = protocol + obj.action + '?' + obj.params;
    // + '&analyticsna=' + obj.analytics;
    // ios9+的 safari 浏览器不可用 iframe，只能用 href
    if (isSafari()) {
        location.href = iosSchema;
    } else {
        setTimeout(() => {
            node.style.display = 'none';
            node.src = iosSchema;
            body.appendChild(node);
        }, 100);
    }
    timer = setInterval(() => {
        count++;
        if (count >= 130) {
            clearInterval(timer);
            let endTime = Date.parse(new Date());
            // 正常时间2600ms，但如果调起成功，会切换后台，导致setInterval执行变缓，就超过了2600
            // 执行下面的逻辑时，如果时间差超过了3000，证明调起成功，否则失败
            if (endTime - startTime >= 3000) {
                alert('success');
                body.contains(node) && body.removeChild(node);
                node = null;
            } else {
                // 下载地址
                alert('error', obj.errorCallback);
                obj.errorCallback();
            }
        }
    }, 20);
}

/**
 * ios 调起入口
 *
 * @param {Object} obj
 */
function callIOS(obj) {
    if (ISWECHAT && callIOS.appConfig.USEAPPLINK) {
        // 提示使用浏览器打开
    } else if (getIOSVersion() >= 9 && callIOS.appConfig.USEUNIVERSALLINK) {
        callByUniversalLink(obj);
    } else {
        callBySchema(obj);
    }
}
callIOS.initConfig = (appConfig) => {
    callIOS.appConfig = appConfig;
};

export default callIOS;